import React from 'react';
import {ShallowRenderer} from './ShallowRender';
import {ShallowRenderingState} from './utils';

interface StreamProductTileWrapperProps {
  shallowRenderingState?: ShallowRenderingState;
  shallowRenderingRootElement?: Element | null;
  shallowRenderingRootMargin?: string;
  productId: number;
  renderTile: (props: {
    isInViewOnRemount: boolean;
    tileRef: React.RefObject<HTMLElement | null>;
  }) => React.ReactNode;
}

export const StreamProductTileWrapper: React.FC<
  StreamProductTileWrapperProps
> = ({
  shallowRenderingState,
  shallowRenderingRootElement,
  shallowRenderingRootMargin,
  productId,
  renderTile,
}) => {
  return (
    <ShallowRenderer
      shallowRenderingState={shallowRenderingState}
      rootElement={shallowRenderingRootElement}
      rootMargin={shallowRenderingRootMargin}
      id={`productTile-${productId}`}
      renderShallowElementCompAs="li"
      renderer={({
        ref,
        isInViewOnRemount,
      }: {
        ref: React.RefObject<HTMLElement | null>;
        isInViewOnRemount: boolean;
      }) => <>{renderTile({isInViewOnRemount, tileRef: ref})}</>}
    />
  );
};
